import { render, staticRenderFns } from "./StudentProfileView.vue?vue&type=template&id=3e28189f&scoped=true&"
import script from "./StudentProfileView.vue?vue&type=script&lang=ts&"
export * from "./StudentProfileView.vue?vue&type=script&lang=ts&"
import style0 from "./StudentProfileView.vue?vue&type=style&index=0&id=3e28189f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e28189f",
  null
  
)

export default component.exports